__turbopack_context__.v({
  "MobileHeader": "LGFi3G_MobileHeader",
  "MobileHeader--Open": "LGFi3G_MobileHeader--Open",
  "MobileHeader--SubLinksOpen": "LGFi3G_MobileHeader--SubLinksOpen",
  "MobileHeader--Unpinned": "LGFi3G_MobileHeader--Unpinned",
  "MobileHeader__AccordionButton": "LGFi3G_MobileHeader__AccordionButton",
  "MobileHeader__AccordionHeading": "LGFi3G_MobileHeader__AccordionHeading",
  "MobileHeader__AccordionItemPanel": "LGFi3G_MobileHeader__AccordionItemPanel",
  "MobileHeader__Button": "LGFi3G_MobileHeader__Button",
  "MobileHeader__Contact": "LGFi3G_MobileHeader__Contact",
  "MobileHeader__ContactLink": "LGFi3G_MobileHeader__ContactLink",
  "MobileHeader__HamburgerMenu": "LGFi3G_MobileHeader__HamburgerMenu",
  "MobileHeader__Icon": "LGFi3G_MobileHeader__Icon",
  "MobileHeader__Line1": "LGFi3G_MobileHeader__Line1",
  "MobileHeader__Line2": "LGFi3G_MobileHeader__Line2",
  "MobileHeader__Line3": "LGFi3G_MobileHeader__Line3",
  "MobileHeader__Link": "LGFi3G_MobileHeader__Link",
  "MobileHeader__ListItem": "LGFi3G_MobileHeader__ListItem",
  "MobileHeader__MainLink": "LGFi3G_MobileHeader__MainLink",
  "MobileHeader__MobileMenu": "LGFi3G_MobileHeader__MobileMenu",
  "MobileHeader__MobileMenuItems": "LGFi3G_MobileHeader__MobileMenuItems",
  "MobileHeader__MobileMenuWrapper": "LGFi3G_MobileHeader__MobileMenuWrapper",
  "MobileHeader__SearchButton": "LGFi3G_MobileHeader__SearchButton",
  "MobileHeader__SubLink": "LGFi3G_MobileHeader__SubLink",
  "MobileHeader__SubListContainer": "LGFi3G_MobileHeader__SubListContainer",
  "MobileHeader__SubListItem": "LGFi3G_MobileHeader__SubListItem",
  "MobileHeader__SubListItems": "LGFi3G_MobileHeader__SubListItems",
  "MobileHeader__ToggleButton": "LGFi3G_MobileHeader__ToggleButton",
  "active": "LGFi3G_active",
});
